import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationsRegisterState, locationsRegisterFeatureKey } from './locations-register.reducer';

const locationsRegisterSelector = createFeatureSelector<LocationsRegisterState>(locationsRegisterFeatureKey);

export const selectFilters = createSelector(locationsRegisterSelector, (state) => {
   return state.filters;
});
